import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function StatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const items = [
    { id: "true", name: t("Active") },
    { id: "false", name: t("Deactivated") },
  ];

  return (
    <Picker
      label={t("Status")}
      showActionBar
      selectionMode="single"
      selectedKeys={params.is_active?.split(",") || []}
      onSelectionChange={(keys) => setParam("is_active", Array.from(keys))}
      items={items}
      testID="status-filter-picker"
    />
  );
}
